module.exports = __webpack_public_path__ + "img/ALQ-FINAL.75137e38.png";